// src/pages/Public/MentionsLegales.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import {
  FiBriefcase,
  FiUser,
  FiMail,
  FiPhone,
  FiGlobe,
  FiFileText,
} from "react-icons/fi";

const MentionsLegales = () => {
  return (
    <>
      <Helmet>
        <title>Mentions Légales - CAC | Chine Afrique Cargo</title>
        <meta
          name="description"
          content="Consultez les mentions légales de CAC - Chine Afrique Cargo. Informations sur l'entreprise, le directeur de publication et l'hébergement."
        />
        <link
          rel="canonical"
          href={window.location.origin + "/mentions-legales"}
        />
      </Helmet>

      <div className="legal-page">
        <div className="legal-hero">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={8}>
                <h1 className="legal-hero-title">⚖️ Mentions Légales</h1>
                <p className="legal-hero-subtitle">
                  Informations légales et obligations réglementaires
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="legal-container py-5">
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="legal-section">
                <div className="legal-info-card">
                  <div className="legal-info-icon">
                    <FiBriefcase size={24} />
                  </div>
                  <div>
                    <h4>Identité de l'entreprise</h4>
                    <p>
                      <strong>Raison sociale :</strong> CAC - Chine Afrique
                      Cargo
                    </p>
                    <p>
                      <strong>Forme juridique :</strong> Société à
                      Responsabilité Limitée (SARL)
                    </p>
                    <p>
                      <strong>Capital social :</strong> 50 000 000 FCFA
                    </p>
                    <p>
                      <strong>RCCM :</strong> CI-ABJ-2024-0001
                    </p>
                    <p>
                      <strong>N° Identification Fiscale :</strong> 1234567890123
                    </p>
                    <p>
                      <strong>N° TVA :</strong> FR12345678901
                    </p>
                  </div>
                </div>

                <div className="legal-info-card">
                  <div className="legal-info-icon">
                    <FiUser size={24} />
                  </div>
                  <div>
                    <h4>Directeur de publication</h4>
                    <p>
                      <strong>Nom :</strong> Jean-Paul KOUADIO
                    </p>
                    <p>
                      <strong>Fonction :</strong> Directeur Général
                    </p>
                    <p>
                      <strong>Email :</strong> jp.kouadio@chineafriquecargo.com
                    </p>
                  </div>
                </div>

                <div className="legal-info-card">
                  <div className="legal-info-icon">
                    <FiMail size={24} />
                  </div>
                  <div>
                    <h4>Coordonnées</h4>
                    <p>
                      <strong>Adresse :</strong> 10 Rue du Commerce, Plateau,
                      Abidjan, Côte d'Ivoire
                    </p>
                    <p>
                      <strong>Téléphone :</strong> +225 27 22 51 00 00
                    </p>
                    <p>
                      <strong>Email :</strong> contact@chineafriquecargo.com
                    </p>
                  </div>
                </div>

                <div className="legal-info-card">
                  <div className="legal-info-icon">
                    <FiGlobe size={24} />
                  </div>
                  <div>
                    <h4>Hébergement</h4>
                    <p>
                      <strong>Hébergeur :</strong> OVH SAS
                    </p>
                    <p>
                      <strong>Adresse :</strong> 2 rue Kellermann, 59100
                      Roubaix, France
                    </p>
                    <p>
                      <strong>Téléphone :</strong> +33 9 72 10 10 07
                    </p>
                  </div>
                </div>

                <div className="legal-info-card">
                  <div className="legal-info-icon">
                    <FiFileText size={24} />
                  </div>
                  <div>
                    <h4>Propriété intellectuelle</h4>
                    <p>
                      L'ensemble du contenu de ce site (textes, images, logos,
                      icônes, etc.) est la propriété exclusive de CAC - Chine
                      Afrique Cargo. Toute reproduction, distribution ou
                      utilisation sans autorisation préalable est interdite.
                    </p>
                  </div>
                </div>
              </div>

              <div className="legal-update">
                <p className="text-muted text-center">
                  Dernière mise à jour :{" "}
                  {new Date().toLocaleDateString("fr-FR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <style>{`
                    .legal-page {
                        background: #f8f9fa;
                        min-height: 100vh;
                    }
                    
                    .legal-hero {
                        background: linear-gradient(135deg, #0a0a2a 0%, #1a1a4e 50%, #0a0a2a 100%);
                        padding: 80px 0 60px;
                    }
                    
                    .legal-hero-title {
                        font-size: 48px;
                        font-weight: 800;
                        color: white;
                        margin-bottom: 16px;
                    }
                    
                    .legal-hero-subtitle {
                        font-size: 18px;
                        color: rgba(255, 255, 255, 0.7);
                    }
                    
                    .legal-section {
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                    }
                    
                    .legal-info-card {
                        background: white;
                        border-radius: 16px;
                        padding: 24px 30px;
                        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
                        display: flex;
                        gap: 20px;
                        align-items: flex-start;
                        transition: all 0.3s ease;
                    }
                    
                    .legal-info-card:hover {
                        transform: translateX(4px);
                        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
                    }
                    
                    .legal-info-icon {
                        width: 50px;
                        height: 50px;
                        min-width: 50px;
                        border-radius: 12px;
                        background: rgba(198, 40, 40, 0.1);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #C62828;
                    }
                    
                    .legal-info-card h4 {
                        font-size: 18px;
                        font-weight: 700;
                        color: #1a1a3e;
                        margin-bottom: 12px;
                    }
                    
                    .legal-info-card p {
                        color: #555;
                        margin-bottom: 4px;
                        line-height: 1.6;
                    }
                    
                    .legal-info-card p strong {
                        color: #1a1a3e;
                    }
                    
                    .legal-update {
                        margin-top: 30px;
                        padding-top: 20px;
                        border-top: 1px solid #e9ecef;
                    }
                    
                    @media (max-width: 992px) {
                        .legal-hero-title {
                            font-size: 36px;
                        }
                    }
                    
                    @media (max-width: 768px) {
                        .legal-hero-title {
                            font-size: 28px;
                        }
                        
                        .legal-info-card {
                            flex-direction: column;
                            padding: 20px;
                        }
                        
                        .legal-info-icon {
                            width: 40px;
                            height: 40px;
                            min-width: 40px;
                        }
                    }
                `}</style>
      </div>
    </>
  );
};

export default MentionsLegales;
